import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../common/reducers/initContext";
import { dataHookFactory } from "../common/reducers/utilities";
import { ensureArray } from "../common/utils/arrayUtilities";

const compareNotificationRules = (r1, r2) => r1.id === r2.id;

const notificationRuleSlice = createSlice({
    name: 'notificationRules',
    initialState: {
        data: []
    },
    reducers: {
        set: (state, action) => {
            state.data = action.payload;
        },
        addOrUpdate: (state, action) => {
            for (const rule of ensureArray(action.payload)) {
                const idx = state.data.findIndex(r => compareNotificationRules(rule, r));
                if (idx > -1) {
                    state.data.splice(idx, 1, rule);
                } else {
                    state.data.push(rule);
                }
            }
        },
        remove: (state, action) => {
            for (const rule of ensureArray(action.payload)) {
                const idx = state.data.findIndex(r => compareNotificationRules(r, rule));
                if (idx > -1) {
                    state.data.splice(idx, 1);
                }
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => notificationRuleSlice.getInitialState());
    }
})

// #region network operations
const fetchAllNotificationRules = network => network.get('/api/v1/notificationRules', notificationRuleSlice.actions.set);
export const createNotificationRule = (network, rule) => network.post('/api/v1/notificationRule', rule, notificationRuleSlice.actions.addOrUpdate);
export const removeNotificationRule = (network, rule) => network.delete('/api/v1/notificationRule/' + encodeURIComponent(rule.id), notificationRuleSlice.actions.remove);
// #endregion

// #region permission checks
export const canCreateNotificationRule = (credentials) => credentials.access.hasFull('administrator');
export const canUpdateNotificationRule = (credentials, rule) => credentials.access.hasFull('administrator');
export const canRemoveNotificationRule = (credentials, rule) => credentials.access.hasFull('administrator');
// #endregion

// #region selector
const selectAll = state => state.notificationRules.data ?? [];
// #endregion

// #region listeners
const listen = {
    notificationRuleCreated: (rule, { dispatch }) => dispatch(notificationRuleSlice.actions.addOrUpdate(rule)),
    notificationRuleDeleted: (rule, { dispatch }) => dispatch(notificationRuleSlice.actions.remove(rule))
}
// #endregion

export const [useNotificationRules] = dataHookFactory(selectAll, { run: fetchAllNotificationRules, listen });

const reducerDetails = { name: notificationRuleSlice.name, reducer: notificationRuleSlice.reducer };
export default reducerDetails;